<script>
	import { onMount } from 'svelte';
	import { writable } from 'svelte/store';
	import Chat from './main/Chat.svelte';
	import Login from './main/Login.svelte';
	import {user, key, currentView} from './store/states.js';
	// Stores for managing state

  
	// Attempt to load the user from local storage or session
	onMount(() => {
	  const storedUser = localStorage.getItem('user');
	  const storedKey = localStorage.getItem('key');
	  if (storedUser && storedKey) {
		user.set(storedUser);
		key.set(storedKey);
		currentView.set('chat');
	  }
	});
  
	// Function to change views
	function navigate(view) {
	  currentView.set(view);
	}
  
	// Function to set user and key
	function setUser(username, keyHex) {
	  localStorage.setItem('user', username);
	  localStorage.setItem('key', keyHex);
	  user.set(username);
	  key.set(keyHex);
	  navigate('chat');
	}
  
	// Function to clear user and key
	async function clearUser() {
		localStorage.removeItem('user');
		localStorage.removeItem('key');
		user.set(null);
		key.set(null);
		// delete from databases using api calls
		await fetch(process.env.DESTROY, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ key_hex: key }),
		});
		navigate('login');
	}

  </script>
  <div style="text-align:center;">
  <h1 class="title is-2" style="padding-top:1rem;">QuantumChat</h1>
  <h3 class="title is-4">Created by <a href="https://grahamzemel.com" style="text-decoration:none;">Graham Zemel</a></h3>
  <!-- <h5 class="title is-6">View the source code <a href="https://github.com/grahamzemel" style="text-decoration:none;">here</a>!</h5> -->
  </div>
  <!-- Conditionally render Login or Chat components based on the currentView -->
  {#if $currentView === 'login'}
	<Login onLogin={setUser} />
  {:else if $currentView === 'chat'}
	<Chat user={$user} key={$key} onLogout={clearUser} />
  {/if}